import { useTranslation } from 'react-i18next'
import type { ProjectTabValue, ProjectViewHeaderProps } from '../types'
import type { PageTabItem } from '@/components/app/layout/PageTabsHeader'
import { PageTabsHeader } from '@/components/app/layout/PageTabsHeader'
import { useProjectCyclesEnabled } from '@/hooks/useProjectCyclesEnabled'

export function ProjectViewHeader({ projectId, activeTab = 'tasks', onTabChange }: ProjectViewHeaderProps) {
  const { t } = useTranslation('projects')
  const { isCyclesEnabled } = useProjectCyclesEnabled(projectId)
  const tabs: Array<PageTabItem<ProjectTabValue>> = [
    { value: 'tasks', label: t('tabs.tasks') },
    { value: 'views', label: t('tabs.views') },
    { value: 'pages', label: t('tabs.docs') },
  ]

  if (isCyclesEnabled) {
    tabs.push({ value: 'cycles', label: t('tabs.cycles') })
  }

  return (
    <PageTabsHeader
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={onTabChange}
    />
  )
}
